<div class="preview-frame-holder" (click)="close(true)">

  <div *ngIf="isLoading" class="iframe-loading-spinner">
    <span><i class="fas fa-spinner fa-spin"></i></span>
  </div> 
  <div class="preview-frame-holder--row-controls-container">
    <!-- <button nbButton ghost>
      <i class="fas fa-trash-alt"></i>
    </button>

    <button nbButton ghost>
      <i class="fas fa-arrows-alt"></i>
    </button> -->

    <button nbButton ghost (click)="downloadFile($event)">
      <i class="fa-light fa-file-arrow-down"></i>
    </button>

    <div class="close-icon" (click)="close(false)"><nb-icon pack="fas" icon="times"></nb-icon></div>
  </div>

  <iframe (load)="loadIframe($event)" *ngIf="pdf" [src]="getURL() | safe"></iframe>


  <div class="image-preview-holder" *ngIf="image">
    <img [src]="data.url | safe" />
    <p class="preview-frame-text">{{ data?.title }}</p>
  </div>